import { Link } from "react-router-dom";
import { Calendar, MapPin, Timer, ChevronRight } from "lucide-react";

function daysUntil(dateStr) {
  return Math.ceil((new Date(dateStr) - new Date()) / 86400000);
}
const isUpcoming = (d) => new Date(d) >= new Date(new Date().toDateString());

const catColor = {
  Slalom: "bg-legend-yellow text-legend-ink",
  Historic: "bg-legend-red text-white",
  CIR: "bg-blue-600 text-white",
  CIAR: "bg-emerald-600 text-white",
  Drift: "bg-purple-600 text-white",
  Storiche: "bg-amber-700 text-white",
  Raduno: "bg-indigo-600 text-white",
  Rally: "bg-slate-700 text-white",
};

export default function RaceWidget({ races = [] }) {
  const upcoming = races.filter((r) => isUpcoming(r.date)).slice(0, 4);

  return (
    <section data-testid="prossime-gare-widget" className="max-w-7xl mx-auto px-4 -mt-6 relative z-10">
      <div className="bg-white dark:bg-legend-paper rounded-sm shadow-xl border-t-4 border-legend-red overflow-hidden">
        <div className="flex items-center justify-between gap-3 px-5 py-3 bg-legend-ink text-white">
          <div className="flex items-center gap-3">
            <Calendar size={18} className="text-legend-yellow" />
            <h2 className="font-display font-bold uppercase text-lg tracking-wide">Prossime Gare Rally</h2>
          </div>
          <Link to="/calendario" data-testid="view-full-calendar" className="text-xs font-mono uppercase tracking-wider text-legend-yellow hover:text-white inline-flex items-center gap-1">
            Calendario completo <ChevronRight size={13} />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-slate-200 dark:divide-slate-800">
          {upcoming.map((r) => {
            const dd = daysUntil(r.date);
            return (
              <Link key={r.id} to={`/calendario?race=${r.id}`} data-testid={`race-item-${r.id}`} className="p-5 hover:bg-slate-50 dark:hover:bg-white/5 transition-colors block">
                <div className="flex items-center justify-between mb-2">
                  <span className={`text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded-sm ${catColor[r.category] || catColor.Rally}`}>{r.category}</span>
                  <div className="flex items-center gap-2">
                    {r.live_url && (
                      <span className="inline-flex items-center gap-1 text-[10px] font-mono font-bold uppercase text-white bg-legend-red px-1.5 py-0.5 rounded-sm">
                        <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" /> Diretta IG
                      </span>
                    )}
                    {dd >= 0 && <span className="inline-flex items-center gap-1 text-[11px] font-mono text-legend-red font-bold"><Timer size={12} /> -{dd}gg</span>}
                  </div>
                </div>
                <h3 className="font-display font-bold uppercase text-lg leading-tight text-slate-900 dark:text-white">{r.name}</h3>
                <p className="mt-1 text-xs text-slate-500 flex items-center gap-1"><MapPin size={12} /> {r.location}</p>
                <p className="mt-2 text-sm font-semibold text-slate-700 dark:text-slate-300">{r.date_label || new Date(r.date).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" })}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-legend-red uppercase tracking-wide">Dettagli & mappa <ChevronRight size={13} /></span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
